export enum ServiceStatus {
    unset,
    loading, 
    loaded,
    error
}